import { Typography } from "@braintrust/braintrust-ui-components";
import type { StripeSEPAPayment } from "@js/types/payments";

import { PaymentMethodMaskedIBAN } from "../../payment-method-masked-iban";

import styles from "../style.module.scss";

type StripeSEPAItemProps = {
  paymentMethod: StripeSEPAPayment;
};

export const StripeSEPAItem = ({ paymentMethod }: StripeSEPAItemProps) => (
  <>
    <div className={styles.paymentMethodsListItemDetailsItem}>
      <Typography
        component="p"
        size="small"
        fontWeight={500}
        color="grey-2"
        className={styles.paymentMethodsListItemDetailsItemName}
        sx={{ textTransform: "uppercase" }}
      >
        IBAN
      </Typography>
      <Typography component="p">
        <PaymentMethodMaskedIBAN
          last4={paymentMethod.method.last4}
          country={paymentMethod.method.country}
        />
      </Typography>
    </div>
  </>
);
